module.exports = __webpack_public_path__ + "cumulativeResidualReturn.5c8617900b25de64eaddd548d7f7ccd6.png";